
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { reportDisplayConfig, reportDisplaySave } from "@/api/userDetection";

@Component({ name: 'prescription-db-component-reportConfigDialog' })
export default class ReportConfigDialog extends Vue {
    @Prop({ type: Boolean, default: false }) visible!: boolean;
    @Prop({ type: [Number, String], default: "" }) diagnosesType!: number | string;
    @Prop({ type: [Number, String], default: "" }) merchantId!: number | string;

    loading = false;
    saveLoading = false;
    configName = "报告配置";
    remark = "";
    configList: any[] = [];

    @Watch("visible")
    onVisibleChange(val: boolean) {
        if (val && this.diagnosesType && this.merchantId) {
            this.getConfig();
        }
    }

    /**
     * 获取配置详情
     */
    getConfig() {
        this.loading = true;
        this.configList = [];
        this.configName = "报告配置";
        this.remark = "";
        reportDisplayConfig({
            diagnosesType: this.diagnosesType,
            merchantId: this.merchantId,
        }).then((res: any) => {
            this.configName = res.data?.configName || "报告配置";
            this.remark = res.data?.remark || "";
            this.configList = res.data?.modules || [];
        }).finally(() => {
            this.loading = false;
        });
    }

    /**
     * 关闭弹窗
     */
    handleClose() {
        this.configList = [];
        this.configName = "报告配置";
        this.remark = "";
        this.$emit("update:visible", false);
    }

    /**
     * 保存
     */
    handleSave() {
        this.saveLoading = true;
        const params = {
            diagnosesType: this.diagnosesType,
            merchantId: this.merchantId,
            modules: this.configList.map((item: any) => ({
                isDisplay: item.isDisplay,
                position: item.position || "",
            })),
        };
        reportDisplaySave(params).then(() => {
            this.$message.success("保存成功");
            this.handleClose();
            this.$emit("success");
        }).finally(() => {
            this.saveLoading = false;
        });
    }
}
